module.exports = __webpack_public_path__ + "static/img/frontBg.344eabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frontBg.png
// module id = OjCy
// module chunks = 0